'use strict';

/**
 * Network
 */
class Network {

	constructor (){
  	this.networkMenu = document.querySelector('.region__network .region--inner');
  	window.addEventListener('resize', this.resizeWindow.bind(this, window));
	}

	resizeWindow(el, e) {
  	let iW = window.innerWidth;
  	let iH = window.innerHeight;
  	let nH = (this.networkMenu.getBoundingClientRect().top + this.networkMenu.getBoundingClientRect().height);
  	// Desktop only:
  	if (iW > 800) {
      	console.log(iH, nH);
    	if (iH < nH) {
      	// Need to do something here:
      	if (iH > 900) {
        	this.networkMenu.classList.add('tall');
      	} else if (iH > 800) {
        	this.networkMenu.classList.add('medium');
      	} else if (iH > 700) {
        	this.networkMenu.classList.add('short');
      	} else {
        	this.networkMenu.classList.add('mini');
      	}
    	} else {
      	console.log('Reset');
      	this.networkMenu.classList.remove('mini','short','tall','medium');
    	}
  	}
  	//console.log(this.networkMenu.getBoundingClientRect().top + this.networkMenu.getBoundingClientRect().height, this.networkMenu.scrollHeight, window.innerHeight);
	}

}

module.exports = Network;
